import { render, staticRenderFns } from "./BillingFrequency.vue?vue&type=template&id=8c02552a&"
import script from "./BillingFrequency.vue?vue&type=script&lang=ts&"
export * from "./BillingFrequency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports